import { Trans } from '@lingui/react'
import { oneOf, string } from 'prop-types'

import {
  AD_SLOT_SEARCH_BRAND_TOP,
  AD_SLOT_SEARCH_CATEGORY_TOP,
} from 'shared/consts/adSlots'
import {
  PAGE_TYPE_BRAND_PAGE,
  PAGE_TYPE_CATEGORY,
  PAGE_TYPE_SEARCH_RESULTS,
  PAGE_TYPES,
} from 'shared/consts/page'
import { isAdServerEnabled } from 'shared/utils/adServerUtils'
import AdBanner from 'views/components/molecules/AdBanner'
import AdSlot from 'views/components/molecules/AdSlot'
import ProductFilterHits from 'views/components/organisms/AlgoliaInstantSearch/ProductFilterHits'
import { usePageProperties } from 'views/utils/shopAndRuntimeConfigUtils'
import './SearchContainerContent.scss'

const SearchContainerContent = ({
  indexName,
  pageType,
  title,
  query,
  noveltiesIndexName,
}) => {
  const { experiments, adPlacements } = usePageProperties()
  const adServerEnabled = isAdServerEnabled(experiments)
  let adBannerPlacement

  if (adServerEnabled && pageType === PAGE_TYPE_CATEGORY) {
    adBannerPlacement = adPlacements?.find(
      item => item?.divName === AD_SLOT_SEARCH_CATEGORY_TOP
    )
  }

  return (
    <>
      {adBannerPlacement && (
        <div className="u-margin--bottom u-margin--top@small-tiny">
          <AdBanner
            id={AD_SLOT_SEARCH_CATEGORY_TOP}
            placement={adBannerPlacement}
            renderBannerOnServerSide
          />
        </div>
      )}
      {title ? (
        <h1 className="o-SearchContainerContent__title">{title}</h1>
      ) : (
        pageType === PAGE_TYPE_SEARCH_RESULTS && (
          <h1 className="o-SearchContainerContent--searchPage">
            <Trans id="general.label.SearchResult" />
          </h1>
        )
      )}

      {!adServerEnabled && pageType === PAGE_TYPE_BRAND_PAGE && (
        <AdSlot id={AD_SLOT_SEARCH_BRAND_TOP} wide paddingBottom />
      )}

      {!adServerEnabled && pageType === PAGE_TYPE_CATEGORY && (
        <AdSlot id={AD_SLOT_SEARCH_CATEGORY_TOP} wide paddingBottom />
      )}

      {indexName && (
        <ProductFilterHits
          query={query}
          indexName={indexName}
          pageType={pageType}
          noveltiesIndexName={noveltiesIndexName}
        />
      )}
    </>
  )
}

SearchContainerContent.propTypes = {
  query: string,
  indexName: string,
  noveltiesIndexName: string,
  pageType: oneOf(PAGE_TYPES),
  title: string,
}

SearchContainerContent.defaultProps = {
  indexName: null,
  pageType: null,
  query: null,
  title: null,
  noveltiesIndexName: null,
}

export default SearchContainerContent
